/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

const GuestProfile = () => {
  const profiles = [
    'CEOs y Directivos con visión de futuro.',
    'Emprendedores que están transformando industrias.',
    'Expertos en economía, tecnología y mercadeo.',
    'Marcas que apuestan por la evolución de Venezuela.',
  ];

  return (
    <Box mt={8}>
      <Typography
        variant="h5"
        component="h2"
        align="center"
        gutterBottom
        sx={{ fontWeight: 700 }}
      >
        ¿A quién buscamos?
      </Typography>
      <Typography
        variant="body1"
        color="textSecondary"
        align="center"
        sx={{ maxWidth: 800, mx: 'auto', mb: 3 }}
      >
        Seleccionamos cuidadosamente a los líderes y organizaciones que forman
        parte de TNO Business para asegurar conversaciones que inspiren,
        generen contexto y marquen la agenda corporativa.
      </Typography>

      <Box maxWidth={600} mx="auto">
        <List>
          {profiles.map((profile) => (
            <ListItem key={profile}>
              <ListItemIcon>
                <CheckCircleOutlineIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary={profile} />
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default GuestProfile;

